export enum PB_SUPPORTED_FEATURES {
  MERCHANDISE = "Merchandise",
  GROUP_CELEBRATION = "GroupCelebration",
  POLL_RESULT_VISIBILITY = "PollResultVisibility",
  EVERYONE_RECOGNITION = "EveryoneRecognition"
}
